// @flow
import React from 'react';
import type { Node } from 'react';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { withStyles } from '@material-ui/core/styles';

import withStdDialog from '../StdDialog';

import { styles } from './styles';

type Props = {
  content: Node,

  onClose: () => void,
  buttonLabel: ?string,

  closeDialog: (Event) => void,
  onRef: (any) => void,
}

class NotificationDialog extends React.PureComponent<Props> {

  static defaultProps = {
    buttonLabel: 'OK',
  };

  componentDidMount() {
    this.props.onRef(this);
  }

  handleClose = (event: Event) => {
    if (this.props.onClose) {
      this.props.onClose();
    }
    this.props.closeDialog(event);
  };

  render() {
    const { buttonLabel, content } = this.props;
    const contentIsString = typeof content === 'string';

    return (
      <>
        <DialogContent>
          {contentIsString &&
            <DialogContentText id="alert-dialog-description">
              {this.props.content}
            </DialogContentText>
          }
          {!contentIsString && content}
        </DialogContent>
        {buttonLabel &&
          <DialogActions>
            <Button id={`notification-${buttonLabel}`} onClick={(event) => this.handleClose(event)} color="primary">
              {buttonLabel}
            </Button>
          </DialogActions>
        }
      </>
    );
  }
}

export default compose(
  withStyles(styles, { name: 'AlertDialog' }),
  withStdDialog(),
)(NotificationDialog);
